import { ModalId } from "../components/modal/types"
import { StockAction } from "./types"

export enum ActionType {
    SET_DISABLE_BRANCH_SELECTOR = 'setDisableBranchSelector',
    SET_OPENED_MODAL = 'setOpenedModal',
    SET_SIDEBAR_EXPANDED = 'setSidebarExpanded',
    SET_STOCK_ACTION = 'setStockAction',
    SET_SPINNER_MODAL_MESSAGE = 'setSpinnerModalMessage',
    SET_MODAL_VALIDATIONS = 'setModalValidations',
    SET_BULK_DATA_TYPE_IDS = 'setBulkDataTypeIds'
}

interface SetDisableBranchSelector {
    type: ActionType.SET_DISABLE_BRANCH_SELECTOR
    payload: boolean
}

interface SetOpenedModal {
    type: ActionType.SET_OPENED_MODAL
    payload?: ModalId
}

interface SetStockAction {
    type: ActionType.SET_STOCK_ACTION
    payload?: StockAction
}

interface SetSpinnerModalMessage {
    type: ActionType.SET_SPINNER_MODAL_MESSAGE
    payload: string
}

interface SetModalValidations {
    type: ActionType.SET_MODAL_VALIDATIONS
    payload: string[]
}

interface SetBulkDataTypeIds {
    type: ActionType.SET_BULK_DATA_TYPE_IDS
    payload: string[]
}

export type UIAction =
    SetDisableBranchSelector |
    SetOpenedModal |
    SetStockAction |
    SetSpinnerModalMessage |
    SetModalValidations |
    SetBulkDataTypeIds
